import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthContext } from "../../front/contexts";
import FrontHeader from "./header"
import { ToastContainer } from "react-toastify";

const RequiresAuth = () => {
  const location = useLocation();
  const { token } = useAuthContext();
  return token ? (
    <>
    <div className="frontClass">
     <ToastContainer hideProgressBar theme="dark" autoClose={2000} />
     <FrontHeader />
    </div>
  </>
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  );
};

export default RequiresAuth;